import Menu from './Menu';
import Button from './Button';

const Profile = (props) => {
    return (
        <div className="relative flex items-center">
          <Button currentUser={props.currentUser}
            btnRef={props.btnRef}
            menuOpen={props.menuOpen}
            setMenuOpen={props.setMenuOpen}
          />
          <Menu 
            currentUser={props.currentUser}
            menuOpen={props.menuOpen}
            menuRef={props.menuRef}              
            onLogout={props.onLogout}
            theme={props.theme}
            setTheme={props.setTheme}
            setMenuOpen={props.setMenuOpen}
          />
        </div>
    );
};

export default Profile;
